module.exports = __webpack_public_path__ + "img/norway-liver-cancer-female.711703dd.png";